import { render, staticRenderFns } from "./TableTemplate.vue?vue&type=template&id=8534e2e4&scoped=true&"
import script from "./TableTemplate.vue?vue&type=script&lang=js&"
export * from "./TableTemplate.vue?vue&type=script&lang=js&"
import style0 from "./TableTemplate.vue?vue&type=style&index=0&id=8534e2e4&prod&lang=css&"
import style1 from "./TableTemplate.vue?vue&type=style&index=1&id=8534e2e4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8534e2e4",
  null
  
)

export default component.exports